import eelms from '../../../assets/EELMS.png'
import rblmhs from '../../../assets/RBLMHS.png'
import tup from '../../../assets/TUP.png'

export const schools = [
    {
        title: 'Bachelor of Science in Electronics Engineering',
        name: 'Technological University of the Philippines Visayas',
        dates: '2013 - 2018',
        logo: tup,
        descriptions: [
            {
                title: "Key Accomplishments",
                paragraphs: 
                [
                    "Graduated with Latin Honors (Cum Laude)",
                    "Best Research Student Award for thesis project",
                    "Awarded Full Academic Scholarship by the Provincial Government of Negros Occidental",
                    "Served as Student Extensionist for the university's electrification project in remote communities"
                ]
            }
        ]
    },
    {
        title: 'Electronics Engineering Technology Diploma',
        name: 'Technological University of the Philippines Visayas',
        dates: '2013 - 2016',
        logo: tup,
        descriptions: [
            {
                title: "Key Accomplishments",
                paragraphs: 
                [
                    "Graduated as 2nd Honor Gold Medalist",
                    "3rd Place, 2015 Panaad sa Negros Festival Agri Quiz Show",
                    "Best Booth at the 2016 Philippine Semiconductor and Electronics Convention and Exhibition"
                ]
            }
        ]
    },    
    {
        title: 'Secondary Education Diploma',
        name: 'Rafael B. Lacson Memorial High School',
        dates: '2009 - 2013',
        logo: rblmhs,
        descriptions: [
            {
                title: "Key Accomplishments",
                paragraphs: 
                [
                    "Class Valedictorian",
                    "President, Negros Occidental Supreme Student Government",
                    "Boy Mayor, 2012 Talisay City Boys and Girls Week",
                    "Philippine Vice President's Leadership Awardee",
                    "Philippine Senate Gold Medal for Academic Excellence",
                    "3rd Congressional District Academic Excellence Awardee",
                    "ABS-CBN Medal of Excellence",
                    "Colegio San Agustin Bacolod Award of Excellence",
                    "University of Negros Occidental Recoletos Award of Excellence",
                    "Tana Dicang Award of Excellence",
                    "Champion, 2012 Minuluan Festival Extemporaneous Speaking",
                    "Champion, 2012 Talisay City Sports Meet Extemporaneous Speaking",
                    "1st Runner-Up, 2011 Minuluan Festival Extemporaneous Speaking",
                    "1st Runner-Up, 2011 Talisay City Sports Meet Extemporaneous Speaking",
                    "2nd Runner-Up, 2012 3rd Congressional District Extemporaneous Speaking",
                    "2nd Runner-Up, 2011 Minuluan Festival Debate",
                    "3rd Runner-Up, 2012 Minuluan Festival Debate",
                    "Semi-finalist, 2012 ABS-CBN Provincial News Casting"
                ]
            }
        ]
    },
    {
        title: 'Elementary Education Diploma',
        name: 'Efigenio-Enrica Lizares Memorial School',
        dates: '2003 - 2009',
        logo: eelms,
        descriptions: [
            {
                title: "Key Accomplishments",
                paragraphs: 
                [
                    "Class First Honorable Mention",
                    "Champion, 2007 Talisay 1 Metrobank MTAP DepEd Math Challenge",
                    "Champion, 2008 Talisay 1 Metrobank MTAP DepEd Math Challenge",
                    "Champion, 2009 Talisay 1 Metrobank MTAP DepEd Math Challenge",
                    "2nd Place, 2009 Talisay 1 Inter-school Math Quiz Bee",
                    "3rd Place, 2007 Division of Negros Occidental Metrobank MTAP DepEd Math Challenge",
                    "3rd Place, 2008 Division of Negros Occidental Metrobank MTAP DepEd Math Challenge",
                ]
            }
        ]
    }
]